import styled from 'styled-components'

export const DivPkMovementInfo = styled.div`
  width: fit-content;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  width: 540px;
  padding: 8px;
  border: 1px;
  border-style: solid;
  border-color: black;
  padding-bottom: 1rem;
`

export const Subtitle = styled.p`
  display: flex;
  justify-content: center;
  font-weight: bold;
  font-size: 18px;
`

export const AddressBox = styled.p`
  background-color: yellow;
  font-weight: bold;
  font-size: 18px;
  border: 1px;
  border-style: solid;
  border-color: black;
  display: flex;
  justify-content: center;
  width: 98%;
  padding: 8px 8px 8px 8px;
`
